import { InverseHeader } from '@jouzen/ecom-components/layout';
import { Button } from '@jouzen/ecom-components/v3/Button';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';

const GiftCallToAction = () => {
  const t = useTranslations();

  return (
    <InverseHeader enter>
      <section className="bg-brown-700 pb-20">
        <LayoutGrid rowGap={32}>
          <div className="col-full lg:col-start-full lg:col-end-13">
            <Image
              src="gift/good-health-desktop"
              localizedAlt="gift_of_good_health_title"
              width={948}
              height={886}
            />
          </div>
          <div className="col-main flex flex-col justify-center pt-5 text-white lg:col-start-15 lg:col-end-22 lg:pt-10">
            <Typography
              Element="h3"
              variant="h2"
              height="tight"
              color="inherit"
              className="mb-5"
            >
              {t('gift_of_good_health_title')}
            </Typography>
            <Typography
              color="inherit"
              variant="unset"
              className="text-2xl xl:text-heading-lg xl:leading-10"
            >
              {t('gift_of_good_health_body')}
            </Typography>
            <div>
              <Button
                href="https://support.ouraring.com/hc/articles/360038973453"
                target="_blank"
                rel="noopener noreferrer"
                variant="secondary-light"
                className="mt-4"
              >
                {t('learn_more')}
              </Button>
            </div>
          </div>
        </LayoutGrid>
      </section>
    </InverseHeader>
  );
};

export default GiftCallToAction;
